import { productSpecificationsEn as base } from './product-specifications-en';

export const productSpecificationsFr = {
  ...base,
  admin: {
    nav: 'Spécifications produit',
    title: 'Spécifications produit',
    description:
      'Définissez des propriétés, schémas, déclarations et mises en page PDF versionnées.',
  },
  tabs: {
    schemas: 'Schémas',
    properties: 'Bibliothèque de propriétés',
    units: 'Unités',
    pdfTemplates: 'Mises en page PDF',
    declarations: 'Déclarations',
    settings: 'Paramètres',
  },
  actions: {
    create: 'Créer une spécification',
    openRevision: 'Ouvrir la révision',
    backToOverview: 'Retour à la vue d’ensemble',
    backToProduct: 'Retour au produit',
    preview: 'Aperçu',
    publish: 'Publier',
    validate: 'Valider',
    submit: 'Soumettre à révision',
    requestChanges: 'Demander des modifications',
    approve: 'Approuver',
    withdraw: 'Retirer',
    generatePdf: 'Générer le PDF',
    download: 'Télécharger',
    addRow: 'Ajouter une ligne',
    moveUp: 'Monter',
    moveDown: 'Descendre',
  },
  fields: {
    name: 'Nom',
    translatedName: 'Nom traduit',
    title: 'Titre',
    text: 'Texte',
    key: 'Clé technique',
    type: 'Type',
    description: 'Description',
    schema: 'Schéma',
    revision: 'Révision',
    version: 'Version',
    validity: 'Validité',
    validFrom: 'Valable à partir du',
    changeReason: 'Motif de modification',
    reason: 'Motif',
    translationStatus: 'État de traduction',
    sectionKey: 'Clé de section',
    sectionTitle: 'Titre de section',
    columns: 'Colonnes',
    pageBreakBefore: 'Saut de page avant',
    required: 'Obligatoire',
    dimension: 'Dimension',
    defaultUnit: 'Unité par défaut',
    translatable: 'Traduisible',
    sensitive: 'Sensible',
    reportable: 'Évaluable',
    symbol: 'Symbole',
    decimalPlaces: 'Décimales',
    conversionFactor: 'Facteur de conversion',
    conversionOffset: 'Décalage de conversion',
    currency: 'Devise',
    minimum: 'Minimum',
    maximum: 'Maximum',
    value: 'Valeur',
    unit: 'Unité',
    tolerance: 'Tolérance',
    toleranceType: 'Type de tolérance',
    measurementMethod: 'Méthode de mesure',
    remark: 'Remarque',
    referenceIds: 'Références internes séparées par des virgules',
    declarationVersionId: 'Version de déclaration',
    confirmed: 'Confirmé',
    confirmationRequired: 'Confirmation requise',
  },
  values: {
    none: 'Aucune',
    required: 'Obligatoire',
    openEnded: 'sans limite',
    yes: 'Oui',
    no: 'Non',
  },
  toleranceTypes: { ABSOLUTE: 'Absolue', PERCENT: 'Pourcentage' },
  states: {
    loadError: 'Les données de spécification n’ont pas pu être chargées.',
    emptyTitle: 'Aucune spécification',
    emptyDescription: 'Créez une spécification à partir d’un schéma publié.',
    noRevision: 'Aucune révision disponible.',
  },
  product: {
    title: 'Spécifications produit',
    description: 'Informations produit versionnées, multilingues et approuvées.',
  },
  create: {
    title: 'Créer une spécification produit',
    description: 'Choisissez un schéma publié et définissez la première révision.',
    selectSchema: 'Choisir un schéma',
    success: 'Spécification créée.',
    error: 'Impossible de créer la spécification.',
  },
  property: {
    ...base.property,
    title: 'Bibliothèque de propriétés',
    description: 'Définitions typées réutilisables pour tous les secteurs.',
    add: 'Ajouter une propriété',
    empty: 'Aucune propriété définie.',
    createSuccess: 'Propriété créée.',
    createError: 'Impossible de créer la propriété.',
    types: {
      SHORT_TEXT: 'Texte court',
      MULTILINE_TEXT: 'Texte multiligne',
      RICH_TEXT: 'Texte enrichi sécurisé',
      INTEGER: 'Entier',
      DECIMAL: 'Décimal',
      PERCENT: 'Pourcentage',
      CURRENCY: 'Devise',
      BOOLEAN: 'Booléen',
      DATE: 'Date',
      DATE_TIME: 'Date et heure',
      SINGLE_CHOICE: 'Choix unique',
      MULTIPLE_CHOICE: 'Choix multiple',
      TRANSLATABLE_CHOICE: 'Choix traduisible',
      MEASUREMENT: 'Valeur avec unité',
      RANGE: 'Intervalle',
      MINIMUM: 'Valeur minimale',
      MAXIMUM: 'Valeur maximale',
      TARGET_TOLERANCE: 'Cible avec tolérance',
      COMPARISON_MEASUREMENT: 'Mesure avec opérateur',
      FORMULA: 'Formule',
      IMAGE: 'Image',
      IMAGE_GALLERY: 'Galerie d’images',
      DMS_FILE: 'Fichier GED',
      CERTIFICATE: 'Référence de certificat',
      PRODUCT_REFERENCE: 'Référence produit',
      URL: 'URL',
      KEY_VALUE_TABLE: 'Table clé-valeur',
      CUSTOM_TABLE: 'Table personnalisée',
      MATRIX: 'Matrice',
      LIST: 'Liste',
      NUMBERED_INSTRUCTIONS: 'Instructions numérotées',
      DECLARATION: 'Déclaration',
      SECTION_HEADING: 'Titre de section',
      INFORMATION: 'Texte d’information',
    },
    configuration: {
      SINGLE_CHOICE: 'Première option',
      MULTIPLE_CHOICE: 'Première option',
      TRANSLATABLE_CHOICE: 'Première option',
      FORMULA: 'Expression de formule',
      KEY_VALUE_TABLE: 'Première colonne',
      CUSTOM_TABLE: 'Première colonne',
      MATRIX: 'Première colonne',
    },
  },
  unit: {
    title: 'Bibliothèque d’unités',
    description: 'Dimensions du tenant et conversions Decimal exactes.',
    add: 'Ajouter une unité',
    createSuccess: 'Unité créée.',
    createError: 'Impossible de créer l’unité.',
  },
  schema: {
    title: 'Schémas de spécification',
    description: 'Composez des formulaires versionnés avec des propriétés réutilisables.',
    add: 'Créer un schéma',
    empty: 'Aucun schéma défini.',
  },
  builder: {
    library: 'Bibliothèque de propriétés',
    inspector: 'Inspecteur',
    addProperty: 'Ajouter {{name}}',
    dropHint: 'Déposez une propriété ici ou utilisez le bouton d’ajout.',
    addSection: 'Ajouter une section',
    saveSuccess: 'Brouillon du schéma enregistré.',
    saveError: 'Impossible d’enregistrer le schéma.',
    versionSuccess: 'Nouvelle version créée.',
    draftAlreadyExists: 'Une version brouillon existe déjà.',
    validationError: 'Vérifiez les clés, traductions et configurations obligatoires.',
    publishSuccess: 'Schéma publié.',
    publishError: 'Impossible de publier le schéma.',
    validationIssues: '{{count}} erreurs de validation restantes.',
  },
  editor: {
    saved: 'Enregistré',
    unsaved: 'Enregistrer les modifications',
    saveError:
      'Impossible d’enregistrer. Rechargez avant d’écraser des modifications concurrentes.',
    completeness: 'Complétude',
    contents: 'Sommaire',
    validationSummary: 'Erreurs de validation',
    sourceText: 'Texte source',
    language: 'Langue',
    workflow: 'Révision et approbation',
    pdf: 'Documents PDF',
    valid: 'La révision est valide.',
  },
  sources: {
    type: 'Source de données',
    field: 'Champ source',
    key: 'Clé source',
    imageVariant: 'Variante d’image',
    packagingId: 'ID emballage (facultatif)',
    automaticSelection: 'Sélection automatique',
    dmsCategory: 'Catégorie GED',
    expression: 'Expression de formule',
    market: 'Marché',
    parameterKey: 'Clé d’analyse (facultative)',
    domainKey: 'Domaine d’analyse',
    allParameters: 'Tous les paramètres sous forme de tableau',
    display: 'Affichage',
    snapshotOnCreate: 'Figer la source à la création',
    refreshOnRevision: 'Actualiser à chaque nouvelle révision',
    copyInitially: 'Copier la valeur initiale',
    showLiveInDraft: 'Afficher la source active dans le brouillon',
    readOnly: 'Lecture seule',
    manuallyOverridable: 'Autoriser une dérogation motivée',
    refresh: 'Actualiser les sources',
    refreshSuccess: 'Les données sources et leur provenance ont été actualisées.',
    refreshError: 'Impossible d’actualiser les données sources.',
    warningTitle: 'Données sources incomplètes ou contradictoires',
    warningItem: 'Le champ source « {{field}} » est incomplet ({{code}}).',
    overrideReason: 'Motif de la dérogation manuelle',
    overrideReasonRequired: 'Un motif est requis pour assurer la traçabilité.',
    overrideReasonSaved: 'Motif enregistré : {{reason}}',
    provenance: 'Source : {{source}} · Version : {{version}}',
    snapshot: 'instantané figé',
    types: {
      MANUAL: 'Saisie manuelle',
      PRODUCT_FIELD: 'Fiche article',
      PRODUCT_CUSTOM_FIELD: 'Champ article personnalisé',
      PRODUCT_CATEGORY: 'Catégorie article',
      PRODUCT_IMAGE: 'Image produit',
      PACKAGING: 'Données emballage',
      DMS_ATTACHMENT: 'Pièce jointe GED',
      FORMULA: 'Formule',
      RECIPE: 'Recette approuvée',
      PRODUCT_DECLARATION: 'Déclaration approuvée',
      ALLERGEN: 'Données allergènes',
      NUTRITION: 'Valeurs nutritionnelles',
      PROCESS_ROUTING: 'Processus approuvé',
      YIELD: 'Rendement',
      ANALYSIS: 'Valeurs d’analyse',
      MATERIAL_PROFILE: 'Fiche matière',
    },
    origins: { MANUAL: 'Manuel', AUTOMATIC: 'Automatique', MANUAL_OVERRIDE: 'Dérogation manuelle' },
    values: {
      articleNumber: 'Numéro d’article',
      name: 'Désignation',
      description: 'Description',
      ean: 'EAN',
      manufacturerNumber: 'Référence fabricant',
      weightNetKg: 'Poids net',
      weightGrossKg: 'Poids brut',
      countryOfOrigin: 'Pays d’origine',
      THUMBNAIL: 'Miniature',
      LIST: 'Vue en liste',
      CATALOG: 'Vue catalogue',
      DETAIL: 'Vue détaillée',
      ALL: 'Tous',
      GENERAL_FILE: 'Fichier général',
      CERTIFICATE: 'Certificat',
      DATASHEET: 'Fiche technique',
      NUMBER: 'Numéro',
      NAME: 'Désignation',
      DESCRIPTION: 'Description',
      BASE_QUANTITY: 'Quantité de référence',
      BASE_UNIT: 'Unité de base',
      COMPONENTS: 'Composants',
      INTERNAL_MATERIAL_COST: 'Coût matière interne',
      DMS_ATTACHMENTS: 'Documents GED',
      PRODUCT_DESIGNATION: 'Dénomination du produit',
      INGREDIENT_TEXT: 'Liste des ingrédients',
      ALLERGEN_TEXT: 'Mention des allergènes',
      ADDITIVE_TEXT: 'Mention des additifs',
      WARNING_TEXT: 'Avertissements',
      COMBINED_TEXT: 'Texte de déclaration combiné',
      STEPS: 'Étapes du processus',
      INSTRUCTIONS: 'Instructions de travail',
      QUALITY_CHECKS: 'Contrôles qualité',
      PHOTOS: 'Photos du processus',
      PERCENT: 'Pourcentage',
      FACTOR: 'Facteur',
      STANDARD_UNIT: 'Unité de quantité standard',
      DENSITY: 'Densité',
      ORIGIN: 'Origine',
      MANUFACTURER: 'Fabricant',
      TECHNICAL_PROPERTIES: 'Propriétés techniques',
      QUALITY_PROPERTIES: 'Propriétés qualité',
      STORAGE_CONDITIONS: 'Conditions de stockage',
      STORAGE_INSTRUCTIONS: 'Instructions de stockage',
      SHELF_LIFE_DAYS: 'Durée de conservation en jours',
    },
  },
  impact: {
    title: 'Nouvelle vérification requise',
    description:
      'Des sources approuvées ont changé. Vérifiez les impacts avant la prochaine approbation.',
    badge: 'Vérification requise',
    count: '{{count}} changements de source affectent cette spécification.',
    item: 'La source « {{source}} » a été modifiée.',
  },
  workflow: {
    submitted: 'Révision soumise.',
    changesRequested: 'Modifications demandées.',
    approved: 'Révision approuvée.',
    published: 'Révision publiée.',
    withdrawn: 'Révision retirée.',
    error: 'Échec de l’action.',
  },
  revisionTools: {
    title: 'Révision et version du schéma',
    createNext: 'Créer la révision suivante',
    created: 'Une nouvelle révision a été créée.',
    createError: 'La nouvelle révision n’a pas pu être créée.',
    compare: 'Comparer avec une révision',
    selectRevision: 'Sélectionner une révision',
    changeCount: '{{count}} modifications',
    noChanges: 'Aucune différence trouvée.',
    changeKind: { ADDED: 'Ajouté', REMOVED: 'Supprimé', CHANGED: 'Modifié' },
    migration: 'Migration contrôlée du schéma',
    selectSchemaVersion: 'Sélectionner une version publiée',
    migrate: 'Créer la révision migrée',
    migrated: 'La révision brouillon migrée a été créée.',
    migrationError: 'La révision n’a pas pu être migrée.',
    migrationCategory: {
      unchanged: 'Champs inchangés',
      new: 'Nouveaux champs',
      removed: 'Champs supprimés',
      incompatible: 'Champs incompatibles',
      carriable: 'Valeurs transférables',
      manual: 'Contrôle manuel',
    },
  },
  settings: {
    title: 'Paramètres des spécifications',
    description: 'Configurez les règles globales de validation, validité et nommage PDF.',
    defaultSourceLocale: 'Langue source par défaut',
    validityWarningDays: 'Avertissement de validité (jours)',
    fileNamePattern: 'Modèle de nom de fichier PDF',
    fileNamePatternHelp:
      'Jetons disponibles : {{articleNumber}}, {{specificationKey}}, {{revision}}, {{locale}}.',
    requireFourEyes: 'Exiger une approbation à quatre yeux par défaut',
    creatorMayApprove: 'Autoriser le créateur à approuver',
    createPdfOnPublish: 'Créer les PDF lors de la publication',
    saved: 'Paramètres enregistrés.',
    saveError: 'Les paramètres n’ont pas pu être enregistrés.',
  },
  declaration: {
    title: 'Déclarations et certificats',
    description: 'Gérez les textes juridiques et sectoriels en versions configurables.',
    createSuccess: 'Déclaration créée.',
    createError: 'Impossible de créer la déclaration.',
    publishSuccess: 'Déclaration publiée.',
    publishError: 'Impossible de publier la déclaration.',
  },
  pdf: {
    ...base.pdf,
    title: 'Concepteur PDF de spécifications',
    description: 'Domaine de mise en page dynamique dédié, basé sur le socle PDF commun.',
    blockLibrary: 'Bibliothèque de blocs',
    inspector: 'Inspecteur de page',
    blockText: 'Texte traduit du bloc',
    addBlock: 'Ajouter le bloc',
    pagePreview: 'Aperçu impression',
    createSuccess: 'Mise en page créée.',
    createError: 'Impossible de créer la mise en page.',
    publishSuccess: 'Mise en page publiée.',
    publishError: 'Impossible de publier la mise en page.',
    previewError: 'Échec de l’aperçu PDF.',
    previewTitle: 'Aperçu de la spécification PDF',
    queued: 'Génération PDF mise en file.',
    combined: 'Langues combinées',
    attachments: 'Annexes GED facultatives',
    attachmentCount: '{{count}} annexes figées',
    generateCombined: 'Document multilingue combiné',
    versionCount: '{{count}} versions',
    status: { PENDING: 'En attente', PROCESSING: 'Génération', READY: 'Prêt', FAILED: 'Échec' },
    blocks: {
      COMPANY_LOGO: 'Logo de l’entreprise',
      COMPANY_ADDRESS: 'Adresse de l’entreprise',
      DOCUMENT_TITLE: 'Titre du document',
      PRODUCT_NAME: 'Nom du produit',
      ARTICLE_NUMBER: 'Numéro d’article',
      PRODUCT_CATEGORY: 'Catégorie produit',
      PRODUCT_IMAGE: 'Image produit',
      IMAGE_GALLERY: 'Galerie d’images',
      SPECIFICATION_NUMBER: 'Numéro de spécification',
      REVISION_NUMBER: 'Numéro de révision',
      STATUS: 'Statut',
      VALIDITY_DATE: 'Validité',
      CREATED_DATE: 'Date de création',
      APPROVED_DATE: 'Date d’approbation',
      SECTION: 'Section de spécification',
      PROPERTY: 'Propriété',
      PROPERTY_GROUP: 'Groupe de propriétés',
      DYNAMIC_TABLE: 'Table dynamique',
      MATRIX: 'Matrice',
      LONG_TEXT: 'Texte long',
      NOTICE: 'Encadré',
      CERTIFICATE_LIST: 'Liste de certificats',
      DMS_FILE_LIST: 'Liste de fichiers GED',
      ATTACHMENT_LIST: 'Liste des annexes',
      APPROVAL: 'Bloc d’approbation',
      REVISION_HISTORY: 'Historique des révisions',
      TABLE_OF_CONTENTS: 'Sommaire',
      HEADER: 'En-tête',
      FOOTER: 'Pied de page',
      PAGE_NUMBER: 'Numéro de page',
      CONFIDENTIALITY: 'Confidentialité',
      WATERMARK: 'Filigrane',
      QR_CODE: 'Code QR de vérification',
      STATIC_TEXT: 'Texte statique traduit',
      CONDITIONAL: 'Bloc conditionnel',
    },
  },
  status: {
    schema: { NEW: 'Nouveau', DRAFT: 'Brouillon', PUBLISHED: 'Publié', ARCHIVED: 'Archivé' },
    revision: {
      DRAFT: 'Brouillon',
      IN_REVIEW: 'En révision',
      CHANGES_REQUESTED: 'Modifications demandées',
      APPROVED: 'Approuvé',
      PUBLISHED: 'Publié',
      SUPERSEDED: 'Remplacé',
      WITHDRAWN: 'Retiré',
    },
    translation: {
      NOT_STARTED: 'Non commencé',
      IN_PROGRESS: 'En cours',
      IN_REVIEW: 'En révision',
      APPROVED: 'Approuvé',
    },
  },
  operators: {
    EQUAL: '=',
    LESS_THAN: '<',
    LESS_THAN_OR_EQUAL: '≤',
    GREATER_THAN: '>',
    GREATER_THAN_OR_EQUAL: '≥',
    RANGE: 'Intervalle',
    APPROXIMATELY: 'Environ',
    NOT_DETECTABLE: 'Non détectable',
    PASSED: 'Conforme',
    FAILED: 'Non conforme',
  },
} as const;
